const applyMobileLabels = (el) => {
  const table = el.tagName === 'TABLE' ? el : el.querySelector('table')
  if (!table) return

  const headers = [...table.querySelectorAll('thead th')].map((th, index, arr) => {
    const label = th.textContent.replace(/\s+/g, ' ').trim()
    if (label) return label
    if (index === arr.length - 1) return 'Action'
    return ''
  })

  table.querySelectorAll('tbody tr').forEach((row) => {
    const cells = row.querySelectorAll('td')
    if (cells.length === 1 && cells[0].hasAttribute('colspan')) {
      cells[0].removeAttribute('data-label')
      return
    }

    cells.forEach((cell, index) => {
      const label = headers[index]
      if (label) {
        cell.setAttribute('data-label', label)
      } else {
        cell.removeAttribute('data-label')
      }
    })
  })

  table.classList.add('table-mobile-ready')
}

export default {
  mounted(el) {
    applyMobileLabels(el)
  },
  updated(el) {
    applyMobileLabels(el)
  }
}
